$(document).ready(function(){

    $('.bag-btn').click(async function(){
        console.time("timer1")
        var bagBtn = document.getElementById("bag-btn");
        bagBtn.classList.remove("hover");
        bagBtn.classList.add("disAbled")
        bagBtn.setAttribute("disabled", true);

        var dots = window.setInterval( function() {

            if ( bagBtn.textContent.length > 14 )
                bagBtn.textContent = "Please Wait";
            else
                bagBtn.textContent += ".";
            }, 100);

        // 2026-04-26 watchdog: even if every other safety net somehow
        // fails (network hang, browser bug, mid-flight tab freeze), this
        // hard 15s timeout will ALWAYS clear the spinner and re-enable
        // the button. Belt and suspenders for the customer-reported
        // "Please Wait..." infinite hang.
        var watchdog = window.setTimeout(function(){
            console.warn('[bags-n-boards] watchdog fired — flow exceeded 15s, resetting UI');
            try { clearInterval(dots); } catch(e) {}
            bagBtn.textContent = "Try Again";
            bagBtn.removeAttribute("disabled");
            bagBtn.classList.remove("disAbled");
        }, 15000);

        // 2026-04-26 hardening (umustbcrazee@yahoo.com hang report):
        // wrap the entire flow in try/catch so the spinner can NEVER
        // hang forever. Previously a single null-product (drafted by the
        // orderable sweep / cutoff cron) inside CheckIfBaggable would
        // throw an uncaught exception and the dots interval never cleared.
        try {
            var cartContents = fetch(window.Shopify.routes.root + 'cart.js')
            .then(response => response.json())
            .then(data => { return data });

            var cartItems =  await cartContents;

            var bagsCount = 0
            var bagsInCart = 0
            console.log(cartItems)

            // Parallelize the per-item baggability check. Sequential
            // round-trips were taking ~200ms × N items — large carts
            // sat on "Please Wait..." for 10+ seconds. Promise.all
            // collapses that to one round-trip's worth of latency.
            var nonBagItems = cartItems.items.filter(function(it){
                return it.product_id != 8721140121830;
            });
            var bagItem = cartItems.items.find(function(it){
                return it.product_id == 8721140121830;
            });
            if (bagItem) bagsInCart = bagItem.quantity;

            var baggables = await Promise.all(nonBagItems.map(function(it){
                // Per-item try/catch so one stale/drafted product can't
                // poison the whole batch — treat unknown as "not baggable".
                return CheckIfBaggable(it.product_id).catch(function(e){
                    console.warn('[bags-n-boards] CheckIfBaggable failed for', it.product_id, e);
                    return false;
                });
            }));
            for (var i = 0; i < nonBagItems.length; i++) {
                if (baggables[i]) bagsCount += nonBagItems[i].quantity;
            }

            if (bagsInCart < bagsCount) {

                var deltaBags = bagsCount - bagsInCart

                let formData = {
                    'items': [{
                    'id': 45047083729126,
                    'quantity': deltaBags
                    }]
                };

                await fetch(window.Shopify.routes.root + 'cart/add.js', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify(formData)
                })
                .then(res=> {return res.json();})
                .catch((error)=> {console.error('Error:', error);});

                console.timeEnd("timer1")
                clearInterval(dots)
                clearTimeout(watchdog)
                bagBtn.textContent = "Adding bags..."
                location.reload()
            }
            else {
                clearInterval(dots)
                clearTimeout(watchdog)
                bagBtn.textContent = "Already Have Enough Bags in Cart"
                return
            }
        } catch (err) {
            // Spinner-clear backstop — unconditionally surface the error
            // and re-enable the button so the customer can retry. The
            // previous code path left the button disabled + spinning
            // forever on any thrown exception (the
            // umustbcrazee@yahoo.com "Please Wait..." hang).
            console.error('[bags-n-boards] failed:', err);
            clearInterval(dots)
            clearTimeout(watchdog)
            bagBtn.textContent = "Try Again"
            bagBtn.removeAttribute("disabled");
            bagBtn.classList.remove("disAbled");
        }

    })

})

async function CheckIfBaggable(prodId) {
    // 2026-04-28 security H-3: coerce prodId to integer before
    // interpolating into a GraphQL string. Shopify's parser would
    // reject most malformed input, but defending in depth defangs any
    // weird cart.js payload (corrupted, double-encoded, etc.).
    var safeProdId = String(parseInt(prodId, 10) || 0);
    productQuery = () => `
    query {
        product(id: "gid://shopify/Product/`+safeProdId+`") {
        m1: metafield(key: "product_type", namespace: "custom") {
      value
    }
        m2: metafield(key: "prod_type", namespace: "custom") {
      value
    }
  }
    }`;


    const STOREFRONT_ACCESS_TOKEN =  window.ECGCE_STOREFRONT_TOKEN
    const GRAPHQL_URL = 'https://ecgce.myshopify.com/api/2024-07/graphql.json'



     GRAPHQL_BODY  = () => {
        return {
        'async': true,
        'crossDomain': true,
        'method': 'POST',
        'headers': {
            'X-Shopify-Storefront-Access-Token': STOREFRONT_ACCESS_TOKEN,
            'Content-Type': 'application/graphql',
        },
        'body': productQuery()
        };
    }



    const res = await fetch(GRAPHQL_URL, GRAPHQL_BODY())
    var obj = await res.json()
    console.log(obj)
    // Defend against deleted/drafted/unknown products — Storefront API
    // returns `data.product = null` for products the customer can't see
    // (e.g. drafts created by the orderable sweep). Without this guard
    // `obj.data.product.m1` throws TypeError → caller's spinner hangs.
    var prod = obj && obj.data && obj.data.product;
    if (!prod) return false;
    var prodType = null;
    if (prod.m1 != null) {
        prodType = prod.m1.value;
    } else if (prod.m2 != null) {
        prodType = prod.m2.value;
    }
    if (prodType == "Comic") {
        return true;
    }
    return false;

    
    
    
    


    


}